import axios from '@/utils/axios'

export default async (data) => {
  const { type, payload } = await axios({
    url: 'register',
    method: 'POST',
    data
  })

  if (type === 200) {
    const { VUE_APP_LOGGED_TOKEN } = process.env
    const { user, access_token: token, message } = payload
    localStorage.setItem(VUE_APP_LOGGED_TOKEN, token)
    return { type: 200, user, message }
  }
  if (type === 422) {
    const { errors } = payload
    const errorFields = Object.keys(errors).reduce((retData, curKey) => {
      retData[curKey] = errors[curKey][0]
      return retData
    }, {})
    return { type: 422, errorFields }
  }
  const { message } = payload
  return { type, message }
}
